<div class="headers-container" #headersContainer>
  <div class="fixed-tabs-header" #fixedTabsContainer (keydown)="handleKeydown($event)">
    <ng-content select="[fixedTabs]"></ng-content>
  </div>


  <div class="paginated-tab-list-container" #tabListContainer (keydown)="handleKeydown($event)">
    <div #tabList class="tab-list" (cdkObserveContent)="onContentChanges()">
      <div class="tab-labels" #tabListInner>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div class="tab-header-pagination">
    <button #previousPaginator [disabled]="disableScrollBefore || null"
      (click)="handlePaginatorClick('before')" (mousedown)="handlePaginatorPress('before', $event)"
      (touchend)="stopInterval()"><i class="icon-content-chevron-left"></i>
    </button>
    <button #nextPaginator [disabled]="disableScrollAfter || null"
      (mousedown)="handlePaginatorPress('after', $event)" (click)="handlePaginatorClick('after')"
      (touchend)="stopInterval()"><i class="icon-content-chevron-right"></i>
    </button>
    <button (click)="isMenuOpen = !isMenuOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <i [class]="isMenuOpen ? 'icon-content-chevron-up' : 'icon-content-chevron-down'"></i>
    </button>
  </div>
</div>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template cdkConnectedOverlay cdkConnectedOverlayHasBackdrop (backdropClick)="isMenuOpen = false" [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOpen">
  <ul class="tabs-menu">
    <ng-content select="[allTabs]">
    </ng-content>
  </ul>
</ng-template>
